import React from "react";
import Style from "./AccardionItemPeyk.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const AccardionItemPeyk = (props) => {
  return (
    <div className={Style.component}>
      {props.accardonItem.map((val) => {
        return (
          <Link
            key={val.id}
            to={val.link}
            className={
              val.active === true
                ? Style.contentChildClicked
                : Style.contentChild
            }
          >
            <FontAwesomeIcon icon={faCircle} className={Style.icon} />
            <p className={Style.contentText}>{val.title}</p>
          </Link>
        );
      })}
    </div>
  );
};

export default AccardionItemPeyk;
